import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";

const ScrollResetHelper = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return <Outlet />;
};
export default ScrollResetHelper;
